import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatPaginator, PageEvent } from '@angular/material';
import { Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CRMOportunidadeAnexo } from 'src/app/models/crm/crmoportunidade-anexo';
import { TipoArquivo } from 'src/app/models/enum';
import { Filtro } from 'src/app/models/filtro';
import { ArquivoService } from 'src/app/services/arquivo.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { CrmoportunidadeAnexoService } from 'src/app/services/crm/crmoportunidade-anexo.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';
import { CadastrarOportunidadeAnexoComponent } from './cadastrar-oportunidade-anexo/cadastrar-oportunidade-anexo.component';

declare const $: any;

@Component({
  selector: 'app-oportunidade-anexo',
  templateUrl: './oportunidade-anexo.component.html',
  styleUrls: ['./oportunidade-anexo.component.scss']
})
export class OportunidadeAnexoComponent implements OnInit {
  // variáveis
  idOportunidade;
  oportunidadeAnexosFiltrados: CRMOportunidadeAnexo[] = [];
  carregando = true;
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  editavel = true;
  paginacao = { tamanhoMaximo: 5, total: 0, paginaAtual: 1 };
  listaDeItensPorPagina = [];
  itensPorPagina = 10;
  filtroNome: Filtro = { Propriedade: 'nome', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  public config: PerfectScrollbarConfigInterface = {};

  @ViewChild('paginatorAnexo', { static: false }) paginator: MatPaginator;

  constructor(
    private oportunidadeAnexoService: CrmoportunidadeAnexoService, private utilitarioService: UtilitarioService,
    private router: Router, private globalService: GlobalService, public dialog: MatDialog, private arquivoService: ArquivoService,
    private carregandoService: CarregandoService, private notificacaoService: NotificacaoService,
    public dialogRef: MatDialogRef<OportunidadeAnexoComponent>, @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.idOportunidade = Number(this.data.idOportunidade);
    this.buscarOportunidadeAnexos();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarOportunidadeAnexos();
    this.paginator.firstPage();
  }

  buscarOportunidadeAnexos() {
    this.carregandoService.mostra('buscaOportunidadeAnexos');
    this.carregando = true;

    this.oportunidadeAnexoService.consultarOportunidadeAnexosComPaginacao(this.idOportunidade, this.filtroNome.Valor, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc').subscribe(dados => {

        this.oportunidadeAnexosFiltrados = dados.itens;
        this.oportunidadeAnexosFiltrados.forEach(a => {
          a.visualizavel = this.utilitarioService.eImagem(a.arquivo) || this.utilitarioService.ePDF(a.arquivo);
        });

        this.listaDeItensPorPagina = this.utilitarioService.calculaItensPorPagina(dados.total);

        if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
          this.itensPorPagina = 10;
        }

        this.paginacao.total = dados.total;

        this.carregando = false;
        this.carregandoService.esconde('buscaOportunidadeAnexos');
      }, (erro) => {
        this.carregandoService.esconde('buscaOportunidadeAnexos');
        this.notificacaoService.erro(erro);
      });
  }

  novoOportunidadeAnexo() {
    const dialogRef = this.dialog.open(CadastrarOportunidadeAnexoComponent, {
      width: ($('body').width()).toString() + 'px',
      data: { idOportunidade: this.idOportunidade },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.buscarOportunidadeAnexos();
      }
    });
  }

  editarOportunidadeAnexo(oportunidadeAnexo: CRMOportunidadeAnexo) {
    const dialogRef = this.dialog.open(CadastrarOportunidadeAnexoComponent, {
      width: ($('body').width()).toString() + 'px',
      data: { id: oportunidadeAnexo.id, idOportunidade: this.idOportunidade },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.buscarOportunidadeAnexos();
      }
    });
  }

  baixarArquivo(anexo: CRMOportunidadeAnexo) {
    this.carregandoService.mostra('baixarArquivo');
    this.arquivoService.baixarArquivo(anexo.id, TipoArquivo.OportunidadeAnexo).subscribe(arq => {
      this.utilitarioService.saveBlob(arq, anexo.arquivo);
      this.carregandoService.esconde('baixarArquivo');
    }, (erro) => {
      this.carregandoService.esconde('baixarArquivo');
      this.notificacaoService.erro(erro);
    });
  }

  excluirOportunidadeAnexo(oportunidadeAnexo: CRMOportunidadeAnexo) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o Anexo?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluiOportunidadeAnexo');
        this.oportunidadeAnexoService.excluir(oportunidadeAnexo.id).subscribe(resp => {

          this.notificacaoService.sucesso('Anexo excluído com sucesso!!!');
          this.carregandoService.esconde('excluiOportunidadeAnexo');
          this.filtra();

        }, (erro) => {
          this.carregandoService.esconde('excluiOportunidadeAnexo');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarOportunidadeAnexos();
  }

  ngOnDestroy(): void {}

  fechar() {
    this.dialogRef.close();
  }

  mostrarPreview(anexo: CRMOportunidadeAnexo) {
    if (anexo.visualizavel) {
      this.carregandoService.mostra('mostrarPreview');
      this.arquivoService.baixarArquivo(anexo.id, TipoArquivo.OportunidadeAnexo).subscribe(arq => {

        if (this.utilitarioService.ePDF(anexo.arquivo)) {
          this.utilitarioService.openBlob(arq);
        } else {
          this.utilitarioService.mostrarImagemBlob(arq, anexo.descricao);
        }

        this.carregandoService.esconde('mostrarPreview');
      }, (erro) => {
        this.carregandoService.esconde('mostrarPreview');
        this.notificacaoService.erro(erro);
      });
    }
  }
}
